/* istanbul ignore file */

import { getColor } from "@aircall/tractor";
import { createGlobalStyle } from "@xstyled/styled-components";
import { FONT_SIZE_BASE_VALUE } from "@/constants/style.constants";

export const GlobalStyle = createGlobalStyle`
  html,
  body {
    overflow: hidden;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    color: ${getColor("text-base")};
    font-family: ${({ theme }: { theme: { fonts: { default: string } } }) =>
      theme.fonts.default};
  }

  /*
   * font-size is body-only, deliberately not on html: CSS rem units resolve
   * against <html>'s font-size, which Tailwind's and @aircall/ds's entire
   * scale assumes is the standard 16px. Pinning html to 14px here silently
   * shrank every rem-based size in the app - both this app's own Tailwind
   * classes and every DS/blocks component's internal typography - to a
   * 14/16 scale-down of its real, intended size. body keeps 14px only for
   * the not-yet-migrated @aircall/tractor / @xstyled consumers that still
   * inherit it via plain CSS cascade (em-based sizing, unrelated to rem).
   */
  body {
    font-size: ${FONT_SIZE_BASE_VALUE}px;
  }

  #root {
    overflow: hidden;
    width: 100%;
    height: 100%;
  }

  * {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: inherit;
  }

  /* avoid having unexpected bigger height on svg when using icon in a button */
  svg {
    display: block;
    line-height: 0;
  }

  a {
    text-decoration: none;
  }
`;
